// global
import IHClassName from './ih_class_name';

var g;
if (typeof google !== 'undefined') {
  g = google.maps;
}

require('promise');
require('bxslider');
require('openlayers');
require('babel-polyfill');

window._ = require('lodash');
window.moment = require('moment');
window.IH = require('ih/z.core');
window.IHExtend = require('ih/extend/' + IHClassName.name);
window.IHGeolocation = require('ih/ih.geolocation');
window.IHGoogleAnalytics = require('ih/modules/IHGoogleAnalytics');
window.IHDirections = require('ih/modules/IHDirections');
window.IHElevation = require('ih/modules/IHElevation');
window.IHKeywordSearch = require('ih/modules/IHKeywordSearch');
//window.IHPlaceList = require('ih/modules/IHPlaceList');


// WEBPACK FOOTER //
// ./map/js/main.js